import {
  BaseSyntheticEvent,
  Dispatch,
  SetStateAction,
  useCallback,
  useRef,
  useState,
} from 'react';
import { Transaction } from '../../../services/types';
import styles from './Header.module.scss';
import shield from '../../../assets/images/shield.svg';
import copyImage from '../../../assets/images/copyBlue.svg';
import success from '../../../assets/images/borderless-success.svg';
import IconButton from '../../atoms/IconButton/IconButton';
import { copyToClipboard } from '../../../services/clipboard';

const Header = ({
  transaction,
  ticketId,
  timeLeft,
  disableTimer = false,
}: {
  transaction: Transaction;
  ticketId: string;
  timeLeft: string;
  disableTimer?: boolean;
}) => {
  const [copiedTransaction, setCopiedTransaction] = useState(false);
  const [copiedUserId, setCopiedUserId] = useState(false);
  const transactionRef = useRef<HTMLSpanElement | null>(null);
  const userIdRef = useRef<HTMLSpanElement | null>(null);
  const { isRedirectUrlExist } = transaction;

  const handleCopy = useCallback(
    (
      e: BaseSyntheticEvent,
      callback: Dispatch<SetStateAction<boolean>>,
      type: 'transaction' | 'user'
    ) => {
      copyToClipboard(
        (type === 'transaction'
          ? transactionRef?.current?.innerText
          : userIdRef?.current?.innerText) || ''
      ).then((ok) => {
        if (!ok) return;
        callback(true);

        setTimeout(() => {
          callback(false);
        }, 1000);
      });
    },
    [transactionRef, userIdRef]
  );

  const handleCopyTransaction = useCallback(
    (e: BaseSyntheticEvent) => {
      handleCopy(e, setCopiedTransaction, 'transaction');
    },
    [handleCopy]
  );

  const handleCopyUserId = useCallback(
    (e: BaseSyntheticEvent) => {
      handleCopy(e, setCopiedUserId, 'user');
    },
    [handleCopy]
  );

  return (
    <div className={styles.wrapper}>
      <div className={`${styles.row} ${styles.rowPrimary}`}>
        <div className={styles.title}>
          <img src={shield} alt='shield' />
          <h3>Пополнение</h3>
        </div>
        {!isRedirectUrlExist && !disableTimer && (
          <p className={styles.timer}>{timeLeft}</p>
        )}
      </div>
      <div className={styles.row}>
        <div className={styles.key}>ID транзакции:</div>
        <div className={styles.value}>
          <span ref={transactionRef} className={styles.overflowText}>
            {ticketId}
          </span>
        </div>
        <IconButton
          className={styles.copy}
          onClick={copiedTransaction ? undefined : handleCopyTransaction}
          active={Boolean(copiedTransaction)}
          dataSentryElement='copy-ticket-id'
        >
          <img
            style={{ objectFit: 'cover' }}
            src={copiedTransaction ? success : copyImage}
            alt={copiedTransaction ? 'Success' : 'Copy'}
            width={12}
            height={12}
          />
        </IconButton>
      </div>
      {transaction?.externalUserId && (
        <div className={styles.row}>
          <div className={styles.key}>ID пользователя:</div>
          <div className={styles.value}>
            <span ref={userIdRef} className={styles.overflowText}>
              {transaction?.externalUserId}
            </span>
          </div>
          <IconButton
            className={styles.copy}
            onClick={copiedUserId ? undefined : handleCopyUserId}
            active={Boolean(copiedUserId)}
            dataSentryElement='copy-user-id'
          >
            <img
              style={{ objectFit: 'cover' }}
              src={copiedUserId ? success : copyImage}
              alt={copiedUserId ? 'Success' : 'Copy'}
              width={12}
              height={12}
            />
          </IconButton>
        </div>
      )}
    </div>
  );
};
export default Header;
